<template src="./PartnerInviteComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant} from "@/supports/app.constant";
import {ref, computed, watch, onMounted} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import InputRangeComponent from "@/components/inputs/input-range/normal/InputRangeComponent.vue";
import {useCompanyStore} from "@/stores/company.js";
import {usePartnerStore} from "@/stores/partner.js";
import SelectCustomWithSearch from "@/components/inputs/select/custom-with-search/SelectCustomWithSearch.vue";
import router from "@/router/index.js";
import ErrorMessageService from "@/services/error-message.service.js";
export default {
  name: 'PartnerInviteComponent',
  components: {
    SelectCustomWithSearch,
    InputRangeComponent,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const errors = ref(true)
    const errorMessage = ref([])
    const actionValidate = ref('')
    const dataInvite = ref({
      name_partner: {
        id: 'name_partner',
        label: 'Công ty',
        placeholder: 'Công ty',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [],
        validations: ['required', ['maxLength', 254]]
      },
      code_partner: {
        id: 'code_partner',
        label: 'Mã công ty',
        placeholder: 'Mã công ty',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 7]]
      },
      email_partner: {
        id: 'email_partner',
        label: 'Email công ty',
        placeholder: 'Email công ty',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'email']
      },
      phone_partner: {
        id: 'phone_partner',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'phone']
      },
      priority_partner: {
        id: 'priority_partner',
        label: 'Mức độ ưu tiên',
        placeholder: 'Mức độ ưu tiên',
        value: '1',
        options: [
          {
            name: 'Cơ bản',
            value: '1'
          },
          {
            name: 'Cần thiết',
            value: '2'
          },
          {
            name: 'Quan tâm',
            value: '3'
          },
          {
            name: 'Quan trọng',
            value: '4'
          },
          {
            name: 'VIP',
            value: '5'
          }
        ],
        error: '',
        isError: false,
        required: true
      },
    })
    const companyIdSelected = ref(null)
    const partnerStore = usePartnerStore()
    const companyStore = useCompanyStore()
    const accountStore = useAccountStore()

    onMounted(() => {
      getListCompanies()
    });

    function validateForm(value, name) {
      const hasError = CommonService.validateForm(value, name, dataInvite)
      const field = dataInvite.value[name]
      if (!field) return hasError

      return hasError
    }
    async function createPartner() {
      actionValidate.value = 'create';
      errors.value = false
      for (const key in dataInvite.value) {
        const hasError = validateForm(dataInvite.value[key].value, key)
        if (hasError) errors.value = true
      }
      if(!errors.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          partner_company_id: companyIdSelected.value,
          partner_name: dataInvite.value.name_partner.value,
          partner_code: dataInvite.value.code_partner.value,
          company_code: accountStore.account.company.company_zip,
          partner_tel: dataInvite.value.phone_partner.value,
          partner_email: dataInvite.value.email_partner.value,
          partner_priority: dataInvite.value.priority_partner.value,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/partner/create-partner';
        const res = await partnerStore.createPartner(url, params);
        const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
        if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
          errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
        } else {
          await CommonService.showAlertPopup({
            title: res?.message,
            icon: res?.status,
            showConfirmButton: false,
            timer: 1200,
            width: '800px'
          });
          if(res?.status === 'success') {
            await router.push('/partner/list')
          }
        }
      }
    }
    function onChange(value, name) {
      dataInvite.value[name].value = value
    }

    const listCompanies = computed(() => {
      return companyStore.listCompanies;
    });

    // call api list partner
    async function getListCompanies() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/companies/company-list';
      await companyStore.getListCompanies(url, params);
      dataInvite.value.name_partner.options = []
      companyStore.listCompanies.forEach((company) => {
        dataInvite.value.name_partner.options.push({
          name: company.company_name,
          value: company.id
        })
      })
    }

    function onChangeUseAvailable(value) {
      dataInvite.value.name_partner.error = ''
      dataInvite.value.name_partner.isError = false
      dataInvite.value.name_partner.value = value;
      companyIdSelected.value = "0";
      if(Number.isInteger(value) && parseInt(value) > 0) {
        companyIdSelected.value = value.toString()
        const companyMatch = listCompanies.value.find((company) => company.id === value)
        if(companyMatch) {
          resetFormInvitePartner()
          dataInvite.value.name_partner.isError = false
          dataInvite.value.code_partner.value = companyMatch.company_zip
          dataInvite.value.phone_partner.value = companyMatch.company_tel
          dataInvite.value.email_partner.value = companyMatch.company_mail_address
          dataInvite.value.name_partner.value = companyMatch.company_name
        }
      }
    }

    watch(() => dataInvite.value.name_partner.value, (partnerId) => {
      const partner = listCompanies.value.find((company) => parseInt(partnerId) === company.id)
      if(partner) {
        dataInvite.value.code_partner.value = partner.company_zip
        dataInvite.value.email_partner.value = partner.company_mail_address
        dataInvite.value.phone_partner.value = partner.company_tel
        dataInvite.value.name_partner.value = partner.company_name
      }
    });

    watch(() => companyStore.listCompanies, (newCompanies) => {
      newCompanies.forEach((company) => {
        dataInvite.value.name_partner.options.push({
          name: company.company_name,
          value: company.id,
        })
      })
    });

    function resetFormInvitePartner() {
      dataInvite.value.code_partner.value = ''
      dataInvite.value.email_partner.value = ''
      dataInvite.value.phone_partner.value = ''
      dataInvite.value.name_partner.value = ''
      dataInvite.value.priority_partner.value = '1'
      companyIdSelected.value = "0";
    }

    function removeError(key) {
      errorMessage.value.splice(key, 1)
    }

    return {
      listCompanies,
      dataInvite,
      errors,
      errorMessage,
      onChangeUseAvailable,
      onChange,
      validateForm,
      createPartner,
      getListCompanies,
      removeError,
      CommonService,
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
